export interface KeyEvent {
  id: number;
  title: string;
  image: string;
  category: string;
  imagePosition?: string; // CSS object-position value for cropping
}

export const keyEvents: KeyEvent[] = [
  // Séminaire
  { id: 1, title: "En bord de mer", image: "/lovable-uploads/seminaire-bord-mer.avif", category: "seminaire" },
  { id: 2, title: "Au vert", image: "/lovable-uploads/seminaire-au-vert.jpg", category: "seminaire" },
  { id: 3, title: "En ville", image: "/lovable-uploads/seminaire-ville.jpg", category: "seminaire" },
  { id: 4, title: "À la montagne", image: "/lovable-uploads/seminaire-montagne.jpg", category: "seminaire" },
  
  // Soirée d'entreprise
  { id: 5, title: "Péniche", image: "/lovable-uploads/soiree-peniche.webp", category: "soiree" },
  { id: 6, title: "Rooftop", image: "/lovable-uploads/soiree-rooftop.jpg", category: "soiree" },
  { id: 7, title: "Lieux de prestige", image: "/lovable-uploads/soiree-lieux-prestige.webp", category: "soiree" },
  { id: 8, title: "Lieux atypiques", image: "/lovable-uploads/soiree-lieux-atypiques.webp", category: "soiree" },
  
  // Activités team building
  { id: 9, title: "Créatif", image: "/lovable-uploads/team-building-creatif.jpg", category: "team-building" },
  { id: 10, title: "Original", image: "/lovable-uploads/team-building-original.jpg", category: "team-building" },
  { id: 11, title: "Sportif", image: "/lovable-uploads/team-building-sportif.jpg", category: "team-building" },
  { id: 12, title: "RSE", image: "/lovable-uploads/team-building-rse.jpg", category: "team-building" },
  
  // Conférence
  { id: 13, title: "Conférence à impact", image: "/lovable-uploads/conference-impact.webp", category: "conference" },
  { id: 14, title: "Symposium", image: "/lovable-uploads/conference-symposium-2.webp", category: "conference", imagePosition: "right" },
  { id: 15, title: "Convention annuelle", image: "/lovable-uploads/conference-convention-annuelle.jpg", category: "conference" },
  { id: 16, title: "Lancement de produit", image: "/lovable-uploads/conference-lancement-produit.jpg", category: "conference" },
];

export const eventCategories = [
  { id: "seminaire", label: "Séminaire" },
  { id: "soiree", label: "Soirée d'entreprise" },
  { id: "team-building", label: "Activités team building" },
  { id: "conference", label: "Conférence" },
];
